import { Component, Injectable } from '@angular/core';
import { Observable, Subject, asapScheduler, pipe, of, from, interval, merge, fromEvent } from 'rxjs';
import { Item } from "../../model/item";

@Injectable({
  providedIn: 'root'
})
export class ItemControlService {

  public item: Item;

  public itemCode: string;

  public procesandoGuardado: Boolean = false;

  public subItem: Subject<subItem> = new Subject();

  /** almacena los items por sesion */
  public totalItems: Item[];

  constructor() {
    this.item = new Item(0, '', 0, 0, 0, 0, '', '', 0, 0, 0, [], '', '', 0, '');
    this.totalItems = [];
  }
}

class subItem {
  id: string;
  cantidadRespuestas: number;
}
